<script lang="ts">
  import type { Snippet } from 'svelte'

  type Props = {
    children: Snippet
  }
  let { children }: Props = $props()
</script>

<div class="stat-card-secondary">
  {@render children?.()}
</div>

<style lang="scss">
  .stat-card-secondary {
    color: var(--foreground-muted);
    display: inline;
    font-size: 1.25rem;
    font-weight: 500;
  }
</style>
